"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinButton = void 0;
var _core = require("@dragon/core");
var _ButtonBase2 = require("../ButtonBase");
require("./SpinButton.scss");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SpinButton = exports.SpinButton = /*#__PURE__*/function (_ButtonBase) {
  function SpinButton(parent, classes, id, action) {
    var _this;
    _classCallCheck(this, SpinButton);
    _this = _callSuper(this, SpinButton, [id, action]);
    _defineProperty(_this, "_node", void 0);
    _defineProperty(_this, "_interval", void 0);
    _defineProperty(_this, "_hyperTicks", 0);
    _defineProperty(_this, "_doingHyperSpin", void 0);
    _defineProperty(_this, "_button", void 0);
    _defineProperty(_this, "_debouncedHyperSpinStart", void 0);
    _defineProperty(_this, "spinIcon", void 0);
    _defineProperty(_this, "stopIcon", void 0);
    _defineProperty(_this, "hyperStart", function (e) {
      // this allows for "hyper spin".
      if (_this._doingHyperSpin) return;
      _this._doingHyperSpin = true;
      _this._button.removeEventListener("touchstart", _this._debouncedHyperSpinStart);

      // console.log('HS START')

      _this._interval = window.setInterval(function () {
        //      console.log('HS TICK')
        if (_this._hyperTicks > 0) _core.CORE.dispatch({
          type: _core.SPIN_BUTTON
        });
        if (_this._hyperTicks == 1) _core.CORE.dispatch({
          type: _core.HYPER_SPIN_START
        });
        //this.onClick();
        _this._hyperTicks++;
      }, 100); // note this will be x2 since QS is before next spin
    });
    _defineProperty(_this, "hyperStop", function (e) {
      if (_this._doingHyperSpin) {
        //     console.log('HS STOPPPP')
        _this._hyperTicks = 0;
        _core.CORE.dispatch({
          type: _core.HYPER_SPIN_STOP
        });
        clearInterval(_this._interval);
        _this._interval = null;
        _this._doingHyperSpin = false;
        setTimeout(function () {
          _this._button.addEventListener("touchstart", _this._debouncedHyperSpinStart, {
            passive: true
          });
        }, 800);
      }
    });
    var idle = "\n        <svg id=\"Layer_1-spin\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 118 118\">\n        <defs>\n          <linearGradient id=\"linear-gradient-spin\" x1=\"59\" y1=\"120\" x2=\"59\" y2=\"2\" gradientTransform=\"matrix(1, 0, 0, -1, 0, 120)\" gradientUnits=\"userSpaceOnUse\">\n            <stop offset=\"0\" stop-color=\"#b48c1b\"/>\n            <stop offset=\"0.51\" stop-color=\"#dac120\"/>\n            <stop offset=\"1\" stop-color=\"#b48c1b\"/>\n          </linearGradient>\n          <radialGradient id=\"radial-gradient-spin\" cx=\"59\" cy=\"59\" r=\"49\" gradientUnits=\"userSpaceOnUse\">\n            <stop offset=\"0.03\" stop-color=\"#c2a01d\"/>\n            <stop offset=\"0.21\" stop-color=\"#c2a01d\"/>\n            <stop offset=\"0.51\" stop-color=\"#c2a01d\"/>\n            <stop offset=\"0.72\" stop-color=\"#dac120\"/>\n            <stop offset=\"1\" stop-color=\"#73580e\"/>\n          </radialGradient>\n          <radialGradient id=\"radial-gradient-spin-2-spin\" cx=\"-78.76\" cy=\"342\" r=\"1\" gradientTransform=\"matrix(0, 42, 42, 0, -14305, 3367)\" gradientUnits=\"userSpaceOnUse\">\n            <stop offset=\"0\" stop-color=\"#cdab30\"/>\n            <stop offset=\"1\" stop-color=\"#e6d051\"/>\n          </radialGradient>\n          <linearGradient id=\"linear-gradient-spin-2-spin\" x1=\"59\" y1=\"103\" x2=\"59\" y2=\"19\" gradientTransform=\"matrix(1, 0, 0, -1, 0, 120)\" gradientUnits=\"userSpaceOnUse\">\n            <stop offset=\"0\" stop-color=\"#feef5f\"/>\n            <stop offset=\"1\" stop-color=\"#836519\"/>\n          </linearGradient>\n        </defs>\n        <circle cx=\"59\" cy=\"59\" r=\"59\" class=\"outerFrame\" style=\"fill: url(#linear-gradient-spin)\" shape-rendering=\"geometricPrecision\"/>\n        <circle cx=\"59\" cy=\"59\" r=\"49\" class=\"innerFrame\" style=\"fill: url(#radial-gradient-spin)\" shape-rendering=\"geometricPrecision\"/>\n        <g>\n          <circle cx=\"59\" cy=\"59\" r=\"42\" style=\"fill: url(#radial-gradient-spin-2-spin)\" class=\"interactive\" shape-rendering=\"geometricPrecision\"/>\n          <circle cx=\"59\" cy=\"59\" r=\"40.5\" style=\"fill: none;stroke-width: 3px;stroke: url(#linear-gradient-spin-2-spin)\" shape-rendering=\"geometricPrecision\"/>\n        </g>\n        <g id=\"stopIcon\">\n          <rect x=\"38\" y=\"38\" width=\"42\" height=\"42\" rx=\"5\" style=\"fill: #fff\"/>\n        </g>\n        <g id=\"spinIcon\">\n          <path d=\"M59,73.4A14.8,14.8,0,0,1,44.2,58.6h7.4L36.8,39.36,22,58.6h7.4A29.57,29.57,0,0,0,77.28,81.85l-9-11.72A14.75,14.75,0,0,1,59,73.4ZM88.6,58.6A29.57,29.57,0,0,0,40.72,35.35l9,11.72A14.79,14.79,0,0,1,73.8,58.6H66.4L81.2,77.84,96,58.6Z\" style=\"fill: #fff\"/>\n        </g>\n      </svg>\n     ";
    _this._node = document.createElement("div");
    _this._node.className = "spinButton wrapper";
    parent.appendChild(_this._node);
    _this._button = document.createElement("div");
    _this._button.className = "button spinButtonLocateHelper";
    _this._node.appendChild(_this._button);
    var content = document.createElement("div");
    content.className = "content main";
    content.innerHTML = idle;
    _this._button.appendChild(content);
    _this._node.onclick = function () {
      return _this.onClick();
    };

    //#region HS
    if (_core.CORE.getState().config.hsAllowed) {
      _this._doingHyperSpin = false;
      _this._debouncedHyperSpinStart = _this.debounce(_this.hyperStart, 500, true);
      _this._button.addEventListener("touchstart", _this._debouncedHyperSpinStart, {
        passive: true
      });

      /**note that UI epic manual throws some of these event to ensure it stops. */
      window.addEventListener("touchmove", _this.hyperStop);
      _this._button.addEventListener("touchcancel", _this.hyperStop);
      _this._button.addEventListener("touchend", _this.hyperStop);
      _this._button.addEventListener("pointerup", _this.hyperStop);
      window.addEventListener("touchcancel", _this.hyperStop);
      _this._button.addEventListener("pointercancel", _this.hyperStop);
      _this._button.addEventListener("pointerout", _this.hyperStop);
      _this._button.addEventListener("pointerleave", _this.hyperStop);
      _this._button.addEventListener("click", _this.hyperStop);
    }
    //#endregion

    // due to possible rendering issues. not present

    setTimeout(function () {
      _this.spinIcon = window.document.getElementById("spinIcon");
      _this.stopIcon = window.document.getElementById("stopIcon");

      //on load its spin button available.
      _core.CORE.subscribe("game.roundState", _this.stateChange.bind(_this));
      _core.CORE.subscribe("game.quickStopAvailable", _this.stateChange.bind(_this));
      _core.CORE.subscribe("game.presentationStopAvailable", _this.stateChange.bind(_this));
      _core.CORE.subscribe("game.gameStatus", _this.stateChange.bind(_this));

      /*
      
            CORE.subscribe("game.reelState", (r: ReelState) => {
              if (r == ReelState.Spinning) {
                this.spinIcon.classList.add("spin");
                this.stopIcon.classList.add("spin");
              }
            });
            CORE.subscribe("game.roundState", (r: RoundState) => {
              if (r == RoundState.Ended) {
                this.spinIcon.removeAttribute("class");
                this.stopIcon.removeAttribute("class");
              }
            });
            CORE.subscribe("game.gameStatus", (e) => {
              if (e == GameStatus.Idle) this.spinIcon.setAttribute("class", "idle");
      
              // when waiting for player input such as freespin dialog
              if (e == GameStatus.PlayerInput) {
                this.spinIcon.removeAttribute("class");
                this.stopIcon.removeAttribute("class");
              }
            });
            CORE.subscribe("game.quickStop", (r: boolean) => {
              if (r) {
                this.stopIcon.classList.add("fade");
              } else {
                this.stopIcon.classList.remove("fade");
              }
            });*/
    }, 0);
    return _this;
  }
  _inherits(SpinButton, _ButtonBase);
  return _createClass(SpinButton, [{
    key: "hideOuterFrame",
    value: function hideOuterFrame() {
      this._node.classList.add("hideOuterFrame");
    }
  }, {
    key: "stateChange",
    value: function stateChange() {
      var state = _core.CORE.getState();
      if (state.game.roundState === _core.RoundState.Ended) {
        this.spinIcon.removeAttribute("class");
        this.stopIcon.removeAttribute("class");
        return;
      } else if (state.game.roundState === _core.RoundState.Started) {
        this.spinIcon.classList.add("spin");
        this.stopIcon.classList.add("spin");
        this.stopIcon.classList.add("fade");
        if (state.game.quickStopAvailable) this.stopIcon.classList.remove("fade");
        if (state.game.presentationStopAvailable) this.stopIcon.classList.remove("fade");
        if (state.game.gameStatus === _core.GameStatus.PlayerInput) {
          this.spinIcon.removeAttribute("class");
          this.stopIcon.removeAttribute("class");
        }
        return;
      }
    }
  }, {
    key: "debounce",
    value:
    ///Basic debouncer
    function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function later() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }
  }, {
    key: "hide",
    value: function hide() {
      this.hyperStop();
      this._node.style.display = "none";
    }
  }, {
    key: "show",
    value: function show() {
      this.hyperStop();
      this._node.style.display = "";
    }
  }]);
}(_ButtonBase2.ButtonBase);
//# sourceMappingURL=SpinButton.js.map